import { Text } from '@rneui/themed'
import { t } from 'app/i18l'
import React from 'react'
import { Pressable, StyleSheet, View } from 'react-native'
import { HomeItem, SummaryItem } from '../../../types'
import { contentComponentMap } from '../../../utils'
import { TileBox } from '../tile_box'
import { DailyPayItem } from './daily_pay_item'
import { TileItemView } from './item'

type Props = {
  item: HomeItem
  onPress(params?: object): void
}

export function ItemTile({ item, onPress }: Props) {
  let error: Error | undefined
  let summaryItems: SummaryItem[]

  if ('summary' in item) {
    summaryItems = item.summary.items
  } else {
    error = item.error
    summaryItems = [
      {
        title: `${t('see')} ${item.title}`,
        description: t('summaryNotAvailable'),
      },
    ]
  }

  // Check if any item has callToAction
  const hasCallToAction = summaryItems.some(
    summaryItem => summaryItem.variant === 'dailyPay'
  )

  return (
    <TileBox>
      <View
        style={[
          styles.container,
          hasCallToAction && styles.containerExpanded,
          summaryItems.length > 0
            ? { backgroundColor: item.backgroundColor }
            : styles.containerEmpty,
        ]}
      >
        {summaryItems.length > 0 && getFirstPage()}
        {summaryItems.length === 0 && (
          <Pressable
            style={styles.emptyTile}
            onPress={() => {
              onPress(item.params)
            }}
          >
            <Text style={styles.emptyMessage}>{`${t('noNew')} ${
              item.title
            }`}</Text>
          </Pressable>
        )}
      </View>
    </TileBox>
  )
  function getFirstPage() {
    return (
      <View
        key={0}
        style={{
          flex: 1,
          marginHorizontal: 15,
        }}
      >
        {summaryItems[0].variant === 'dailyPay' ? (
          <DailyPayItem
            item={summaryItems[0]}
            color={item.color}
            error={error}
          />
        ) : (
          <TileItemView
            item={summaryItems[0]}
            ContentComponent={
              summaryItems[0].contentComponentKey
                ? contentComponentMap[summaryItems[0].contentComponentKey]
                : undefined
            }
            color={item.color}
            error={error}
            onPress={() => onPress(summaryItems[0].params)}
          />
        )}
      </View>
    )
  }
}

export const styles = StyleSheet.create({
  container: {
    minHeight: 100,
    paddingVertical: 5,
    justifyContent: 'space-evenly',
  },
  containerExpanded: {
    minHeight: 163, // Larger height when there's a call-to-action
  },
  containerEmpty: {
    backgroundColor: '#BCBACE',
  },
  emptyTile: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyMessage: {
    color: 'black',
    fontSize: 16,
    paddingTop: 10,
    opacity: 0.6,
  },
})
